/* Common variables */

//var typo3Path = '/typo3conf/ext/stratis_site/Resources/Public/'; // Remove because doesn't work in http://integration.stratis.fr/typo3-8.7/page-content.html
var cmsPath = 'typo3conf/ext/stratis_site/Resources/Public/';

var pathImg = cmsPath + "Images/",
    pathImgFancybox = cmsPath + "Images/fancybox/";
